import React, { useState } from "react";

import PaidInvoices from "./PaidInvoices";
const PaidInvoicesMainPage = ({}) => {
  return (
    <div className="pt-[83px]">
    {" "}
    <PaidInvoices />
  </div>
  );
};

export default PaidInvoicesMainPage;
